import {
  DatePickerWithInput,
  HeadingGroup,
  ModalLayout,
  // Pagination,
  // Table,
  ConfirmationBox
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import Style from "../../Billings/staffBilling.module.scss";
import useActivityLog from "./useActivityLog";
import Select from "react-select";
import { Pagination } from "../../Global/Pagination";
import { Table } from "../../Global/Table";

const ActivityLog = () => {
  const {
    paginationOptions,
    activitylogList,
    isFetching,
    tableFields,
    showEditModal,
    activitylogState,
    globalState,
    date,
    handleClick,
    handleDateChange,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    updateEstimateFields,
    handleEditColumnsClick,
    handleDeleteModal,
    handleDelete,
    refetch,
    getRow,
    formik,
    departmentData,
    activitylogData,
  } = useActivityLog();

  return (
    <div>
      <HeadingGroup title={"Activity Log"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="col-auto pro-pt-3 ">
          <div className="row gx-2 gy-2 ">
            <div className={`col-4`}>
              <div className="input-wrap">
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search GLI Number, Process"
                  className={`pro-input icon-r lg search-input ${Style.search_table}`}
                />
                <span className="pro-icon">
                  {<span className="material-symbols-outlined">search</span>}
                </span>
              </div>
            </div>

            <div className={`col-auto`}>
              <DatePickerWithInput
                CalendarOutlineIcon={
                  <span className="material-symbols-outlined">
                    calendar_month
                  </span>
                }
                range={true}
                initialValue={date}
                onDateChange={handleDateChange}
              ></DatePickerWithInput>
            </div>

            <div className="col-2">
              <div className="pro-d-flex pro pro-items-center pro-gap-2 pro-ms-auto">
                <label
                  htmlFor="department"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Department
                </label>
                <Select
                  id="department"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="department"
                  options={departmentData?.data?.data}
                  getOptionValue={(option) => option?._id}
                  getOptionLabel={(option) => option?.name}
                  value={formik?.values?.department}
                  onChange={(value) =>
                    formik.setFieldValue("department", value)
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="col-2">
              <div className="pro-d-flex pro-items-center pro-gap-3 pro-ms-auto">
                <label
                  htmlFor="activity-log-type"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Type
                </label>
                <Select
                  id="activity-log-type"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="activity-log-type"
                  options={activitylogData?.data}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.title}
                  value={formik?.values?.activitytype}
                  onChange={(value) =>
                    formik.setFieldValue("activitytype", value)
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>

            <div className="col-2">
              <div className="pro-d-flex pro-items-center pro-gap-3 pro-ms-auto">
                <label
                  htmlFor="activity-log-type"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Branch
                </label>
                <Select
                  id="branch"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="branch"
                  // options={globalState?.branchList?.branch_list}
                  options={[
                    { _id: "", branch_name: "All" },
                    ...(globalState?.branchList?.branch_list || []),
                  ]}
                  getOptionValue={(option) => option?._id}
                  getOptionLabel={(option) => option?.branch_name}
                  value={
                    formik.values.brach_id || { _id: "", branch_name: "All" }
                  }
                  onChange={(value) => formik.setFieldValue("brach_id", value)}
                  menuPlacement="auto"
                />
              </div>
            </div>
                        <div className={`col-auto`}>
              <button
                className={`pro-btn pro-btn-primary  pro-ms-3 items-center `}
                onClick={handleClick}
              >
                <span class="material-symbols-outlined x2">download</span>
                <span>Export</span>
              </button>
            </div>

              <div className={`col-auto`}>
              <button
                className={`pro-btn pro-btn-primary  pro-ms-3 items-center `}
                onClick={handleDeleteModal}
              >
                <span class="material-symbols-outlined x2">Delete</span>
                <span>Delete</span>
              </button>
            </div>
          </div>
        </div>
       <ModalLayout
          show={activitylogState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the activity logs older than 3 months ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>
        <Table
          multiSelect={false}
          data={activitylogList?.data?.data || []}
          uniqueID={"id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={activitylogState?.currentPageSize}
          assignable={false}
          clear={activitylogState?.clear}
          // extraClasssName="table-wrapper tbl-h lg"
        />
        {activitylogList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={activitylogState?.currentPage}
            totalPageCount={Math.ceil(
              activitylogList?.data?.total_count /
                activitylogState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={activitylogList?.data?.fields}
              moduleId={activitylogList?.data?.module_id}
              updateData={updateEstimateFields}
            />
          </div>
        </ModalLayout>
      </div>
    </div>
    // </div>
  );
};

export default ActivityLog;
